import useWidgetActions from '../../../hooks/useWidgetActions.js';
const useSearchResultsActions = () => {
    return useWidgetActions();
};
export default useSearchResultsActions;
